import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Line, Bar} from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    annotationPlugin,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


import {FilterSet, MenuNode, MenuNodeCfgSet, StaffUtilisationDataSet} from "./types.ts";
import * as React from 'react';
import {VirtualItem, Virtualizer} from "@tanstack/react-virtual";
import {COL_WIDTH_BY_INTERVAL} from "./VirtualisedGrid.tsx";
import {useEffect, useRef} from "react";
import {Staff} from "../Components/BaseTypes.ts";

interface PropTypes {
    menuNodesToRender: MenuNode[],
    utilisationData: StaffUtilisationDataSet,
    filters: FilterSet,
    staff: { [staffCallname: string]: Staff[] },
    virtualColumns: VirtualItem[],
    scroll: number,
    menuNodeCfgSet: MenuNodeCfgSet,
    setMenuNodeCfgSet: React.Dispatch<React.SetStateAction<MenuNodeCfgSet>>,
}

export function UtilisationGraph({
                                     menuNodesToRender,
                                     utilisationData,
                                     filters,
                                     staff,
                                     virtualColumns,
                                     menuNodeCfgSet,
                                     setMenuNodeCfgSet
                                 }: PropTypes) {
    let annotations =
        {
            good: {
                type: 'box',
                yMin: 80,
                yMax: 120,
                backgroundColor: 'rgba(159,206,99,0.2)'
            },
            bad: {
                type: 'box',
                yMin: 120,
                backgroundColor: 'rgba(234,51,35,0.2)'
            }
        };
    const isLeaveHoursGraph = (menuNodesToRender[0]?.hoursType === 'leaveHours');

    let yUnit = '%';

    if (menuNodesToRender && menuNodesToRender.length && isLeaveHoursGraph) {
        yUnit = 'h';
        annotations = {};
    }

    const leaveYMax =
        filters.interval == 'daily' ? 8 :
            filters.interval == 'weekly' ? 40 :
                filters.interval == 'fortnightly' ? 80 :
                    filters.interval == 'monthly' ? 160 : 100


    const datasets =
        menuNodesToRender.map(menuNode => {
            const staffColour = '#' + intToRGB(hashCode(menuNode.name));
            return {
                id: menuNode.key,
                // showLine: false,
                label: menuNode.name,
                borderColor: staffColour,
                backgroundColor: staffColour,
                data: virtualColumns.map((virtualColumn) => {
                    const id = virtualColumn.index - 2;
                    const date = utilisationData.dateIndexes[id];

                    if (!date) {
                        return null;
                    }

                    const staffCallname = menuNode.staffCallname;
                    const maxValue =
                        menuNode.rootLevelGroup === 'group' ?
                            utilisationData.group[menuNode.id]?.periodHours[id]
                            : filters.interval === 'daily' ?
                                staff[staffCallname]?.['hoursPerDay'][date.getUTCDay()] * (id in (utilisationData.workDayDates?.[staffCallname] || []) ? utilisationData.workDayDates[staffCallname][id] : 1) :
                                utilisationData.staff[staffCallname]?.periodHours[id]

                    const value = ((menuNode.subLevelGroup === 'staff' || menuNode.subLevelGroup === 'group') ?
                        utilisationData[menuNode.rootLevelGroup][menuNode.rootLevelId]?.[menuNode.hoursType]?.['date']?.[id] :
                        utilisationData.staff[staffCallname]?.[menuNode.hoursType]?.[menuNode.subLevelGroup]?.[menuNode.id]?.[id]) || 0;

                    console.log(maxValue);
                    if (!maxValue && menuNode.hoursType !== 'leaveHours') {
                        console.log('return null');
                        return null;
                    }

                    return menuNode.hoursType === 'leaveHours' ? value?.toFixed(1) : (value / maxValue * 100).toFixed(1);
                })
            }
        });

    (datasets?.length > 1) && !isLeaveHoursGraph && datasets.unshift(
        {
            id: 'Average',
            label: 'Average',
            borderColor: '#' + intToRGB(hashCode('Average')),
            backgroundColor: '#' + intToRGB(hashCode('Average')),
            data: virtualColumns.map((virtualColumn, i) => {
                const id = virtualColumn.index - 2;
                const date = utilisationData.dateIndexes[id];

                if (!date) return null;

                let totalPercentForDate = 0;
                datasets.forEach(dataset => {
                    totalPercentForDate += (parseFloat(dataset.data[i]) || 0);
                })

                return (totalPercentForDate / datasets.length).toFixed(1);
            })

        }
    )
    // if (chart && chart.legend?.legendItems?.length && menuNodeCfgSet['mel']?.legendItems) {
    datasets.forEach(((dataset, i) => {
        if (!menuNodeCfgSet[dataset.id]) menuNodeCfgSet[dataset.id] = {};
        if (menuNodeCfgSet[dataset.id].legendItemHidden) {
            dataset.hidden = true;
        } else {
            dataset.hidden = false;
        }
    }));
    // menuNodeCfgSet['mel'].legendItems.forEach((legendItem, i) => {
    //     if (legendItem.hidden) {
    //         console.log(chart.getDatasetMeta((i)));
    //         chart.getDatasetMeta(i).hidden = legendItem.hidden;
    //     }
    // })
    // chart.update();
    // chart.legend.legendItems = menuNodeCfgSet['mel'].legendItems;
    // }

    const chartRef = useRef<ChartJS>(null);

    useEffect(() => {
        // const chart = chartRef.current;

        // }, 500);


        // loadLegendData(chart, menuNodeCfgSet);
    }, []);


    console.log('render graph');
    return (menuNodesToRender?.length || filters.graph) && (
        <div style={{
            resize: 'vertical',
            height: '100%',
            minHeight: '250px',
            width: ((virtualColumns.length - 1) * COL_WIDTH_BY_INTERVAL[filters.interval]) + 50
        }}>
            <Line
                // width={dateObjectsToRender.length * 72}
                datasetIdKey='id'

                ref={chartRef}
                options={{
                    layout: {
                        padding: 0
                    },
                    stepped: true,
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: false,
                    elements: {
                        point: {
                            radius: 5
                        },
                        line: {}
                    },
                    scales: {
                        y: {
                            suggestedMax: isLeaveHoursGraph ? leaveYMax : 100,
                            suggestedMin: 0,
                            ticks: {
                                callback: function (value) {
                                    return value + yUnit;
                                },
                                // display: false,
                                beginAtZero: true,
                            },
                            grid: {
                                tickWidth: 0,
                                tickLength: 0,
                            }
                        },
                        x: {
                            ticks: {
                                beginAtZero: true,
                                display: false,
                            },
                            grid: {
                                drawOnChartArea: false,
                                tickWidth: 0,
                                tickLength: 0,
                            }
                        }

                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            onClick: (e, legendItem, legend) => {
                                // const index = legendItem.datasetIndex;
                                // const ci = legend.chart;
                                // if (ci.isDatasetVisible(index)) {
                                //     ci.hide(index);
                                //     legendItem.hidden = true;
                                // } else {
                                //     ci.show(index);
                                //     legendItem.hidden = false;
                                // }

                                console.log(legendItem);

                                const menuNode = menuNodesToRender[isLeaveHoursGraph ? legendItem.datasetIndex : legendItem.datasetIndex - 1] || {key: 'Average'};

                                if (!menuNodeCfgSet[menuNode.key]) menuNodeCfgSet[menuNode.key] = {};
                                const menuNodeCfg = menuNodeCfgSet[menuNode.key];

                                menuNodeCfg.legendItemHidden = legend.chart.isDatasetVisible(legendItem.datasetIndex);

                                // if (!menuNodeCfgSet['mel']) menuNodeCfgSet['mel'] = {};
                                // menuNodeCfgSet['mel'].legendItems = legend.legendItems;
                                setMenuNodeCfgSet({...menuNodeCfgSet});
                            }
                        },
                        title: {},
                        annotation: {
                            annotations: annotations
                        }
                    }
                }}
                data={{
                    // labels: utilisationData.dateIndexes.map(date => `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`),
                    // labels: dateObjectsToRender.map(date => `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`),
                    labels: virtualColumns.map(virtualColumn => {
                        const date = utilisationData.dateIndexes[virtualColumn.index - 2];
                        return date ? `${date.getUTCDate().toString().padStart(2, '0')}` : 'o'
                    }),
                    datasets: datasets
                }}
            />
        </div>
    )
}

function hashCode(str) { // java String#hashCode
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}

function intToRGB(i) {
    const c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
}

function loadLegendData(chart: ChartJS, menuNodeCfgSet: MenuNodeCfgSet) {

}